module.exports = __webpack_public_path__ + "img/skirt_4.cbe07308.png";